import { useState } from "react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { ButtonMui, HomeTitle } from "@/components/ui";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { SectionLayout } from "@/layouts";
import { CardInfoItems, ImgCard } from "./overviewComponents";
import { BtnContainer, CustomTab, CustomTabs } from "./overviewComponents/overviewComponents";
import { SectionTitle, TitleContainer } from "@/pagePartials/home/home.styles";
import { ContainerLarge, ImageContainer, ItemSelectors, OverviewContainer, SelectedBox, TextContainer, TitleLarge, TitleSmall } from "./serviceOverview.styles";

//preloader image to avoid flickering

const ServiceOverviewScreen = () => {
  const { t } = useTranslation("global");

  const [selected, setSelected] = useState("software");
  const [active, setActive] = useState(false);
  const [value, setValue] = useState(0);

  const selectors = ["software", "hardware", "integration", "consulting"];

  const handleChnage = (item: string, index: number) => {
    setSelected(item);
    setValue(index);
    setActive(true);
    setTimeout(() => {
      setActive(false);
    }, 700);
  };

  return (
    <SectionLayout id="services">
      <OverviewContainer>
        {/* Title small */}
        <TitleSmall>
          <HomeTitle className="headline-small weight-medium" color={"var(--primary-light)"} borderColor={"var(--primary-light)"}>
            {t("overviewTtitle.title")}
          </HomeTitle>
          <SectionTitle className="display-large" color="var(--on-surface-light)">
            {t("overviewTtitle.description")}
          </SectionTitle>
        </TitleSmall>
        {/* --- */}

        <ContainerLarge>
          <ImageContainer className={active ? "animate__animated animate__fadeIn" : " "}>
            <ImgCard cardPath={`/assets/overviewMobile/${selected ? selected : "software"}.webp`} active={active} size="small" />
            <ImgCard cardPath={`/assets/overviewDesk/${selected ? selected : "software"}.webp`} active={active} size="large" />
          </ImageContainer>

          <TextContainer>
            {/* Title large */}
            <TitleLarge>
              <TitleContainer aItem="flex-start">
                <HomeTitle className="headline-small weight-medium" color={"var(--primary-light)"} borderColor={"var(--primary-light)"} mb="1.25rem">
                  {t("overviewTtitle.title")}
                </HomeTitle>
                <SectionTitle className="display-large" color="var(--on-surface-light)">
                  {t("overviewTtitle.description")}
                </SectionTitle>
              </TitleContainer>
            </TitleLarge>
            {/* ---*/}
            <ItemSelectors>
              <CustomTabs value={value} centered variant="fullWidth">
                {selectors.map((item, index) => (
                  <CustomTab key={index} label={item} onClick={() => handleChnage(item, index)} />
                ))}
              </CustomTabs>
            </ItemSelectors>
            <SelectedBox>
              <CardInfoItems selected={selected} active={active} />
            </SelectedBox>
            <BtnContainer>
              <Link href="/contact">
                <ButtonMui size="medium" variant="contained" color="primary" endIcon={<ArrowForwardIcon />}>
                  {t("overviewTtitle.button")}
                </ButtonMui>
              </Link>
            </BtnContainer>
          </TextContainer>
        </ContainerLarge>
      </OverviewContainer>
    </SectionLayout>
  );
};

export default ServiceOverviewScreen;
